import { Lesson } from '.';
export class DailyLessonDaysLesson {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyLessonDayId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessonId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.dailyLessonDayId = data.dailyLessonDayId;
        this.lessonId = data.lessonId;
        this.orderIndex = data.orderIndex;
        this.lesson = new Lesson(data.lesson, config);
    }
}
